export default __webpack_public_path__ + "static/media/background_horoscope.2b06740f.jpg";